import { calcPosFromAngles } from '@react-three/drei'
import * as THREE from 'three'

// Example custom hotspot camera positions
// You can modify these positions and targets to fine-tune camera angles for each hotspot

export const CUSTOM_HOTSPOT_POSITIONS = {
    headlight: {
        // Camera position when viewing headlight - closer to the front-right of the car
        position: new THREE.Vector3(0, 2.5, 9), // x, y, z coordinates
        // Where the camera should look at
        target: new THREE.Vector3(0, 0, -0.4),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        // Camera movement constraints when in this hotspot view
        constraints: {
            minPolarAngle: Math.PI / 3.5, // Minimum vertical angle (higher = more upward)
            maxPolarAngle: Math.PI / 2.1,  // Maximum vertical angle (lower = more downward)
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit (-30 degrees)
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit (30 degrees)
            minDistance: 1.2,              // Closest zoom
            maxDistance: 4.5,              // Farthest zoom
            dampingFactor: 0.08            // Smoothness of movement
        }
    },

    taillight: {
        // Camera position when viewing taillight  
        position: new THREE.Vector3(0, 2, -9),
        // Where the camera should look at
        target: new THREE.Vector3(0, 0.3, -2.5),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        // Camera movement constraints
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 4.5,
            dampingFactor: 0.08
        }
    },

    dramaticFraming: {
        // Camera position when viewing headlight - closer to the front-right of the car
        position: new THREE.Vector3(-9.4, 0, 8), // x, y, z coordinates
        // Where the camera should look at
        target: new THREE.Vector3(0.2, 2, -0.5),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        // Camera movement constraints when in this hotspot view
        constraints: {
            minPolarAngle: Math.PI / 3.5, // Minimum vertical angle (higher = more upward)
            maxPolarAngle: Math.PI / 1.7,  // Maximum vertical angle (lower = more downward)
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit (-30 degrees)
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit (30 degrees)
            minDistance: 1.2,              // Closest zoom
            maxDistance: 4.5,              // Farthest zoom
            dampingFactor: 0.08            // Smoothness of movement
        }
    },

    // Example: Add more hotspots as needed
    cleanLines: {
        position: new THREE.Vector3(10, 1, -0.4),
        target: new THREE.Vector3(3, 1, -0.4),
        // Example: Clean lines hotspot with camera lock disabled
        lockCamera: true,
        constraints: {
            minPolarAngle: Math.PI / 4,
            maxPolarAngle: Math.PI / 2.5,
            minAzimuthAngle: -Math.PI / 4,
            maxAzimuthAngle: Math.PI / 4,
            minDistance: 0.8,
            maxDistance: 2.5,
            dampingFactor: 0.06
        }
    },

    trunk: {
        // Camera position when viewing trunk
        position: new THREE.Vector3(0, 2, -9),
        // Where the camera should look at
        target: new THREE.Vector3(0, 0.3, -2.5),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        // Camera movement constraints
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 4.5,
            dampingFactor: 0.08
        }
    },

    craftedToPerform: {
        // Camera position when viewing craftedToPerform
        position: new THREE.Vector3(-7, 1.5, 6),
        // Where the camera should look at
        target: new THREE.Vector3(4, 0, 0),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 4.5,
            dampingFactor: 0.08
        }
    },

    engineeredToPerform: {
        // Camera position when viewing engineeredToPerform
        position: new THREE.Vector3(-8, 1.5, 1.5),
        // Where the camera should look at
        target: new THREE.Vector3(6, 0, 2),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 4.5,
            dampingFactor: 0.08
        }
    },

    sophisticatedTouch: {
        // Camera position when viewing sophisticatedTouch
        position: new THREE.Vector3(8, 2, 5),
        // Where the camera should look at
        target: new THREE.Vector3(-3, 0, 0),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 4.5,
            dampingFactor: 0.08
        }
    },

    sculptedStrength: {
        // Camera position when viewing sculptedStrength - Step 1: Front-right view (shows all 3 hotspots)
        position: new THREE.Vector3(6, 1, 7),
        // Where the camera should look at
        target: new THREE.Vector3(0, 0, 0),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 7,
            dampingFactor: 0.08
        }
    },

    sculptedStrengthRear: {
        // Camera position when viewing sculptedStrength - Step 2: Rear view (close-up of rear diffuser)
        position: new THREE.Vector3(3, 1, -9),
        // Where the camera should look at
        target: new THREE.Vector3(0, 0.3, -2.5),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 4.5,
            dampingFactor: 0.08
        }
    },

    powerMeetsPrecision: {
        // Camera position when viewing sophisticatedTouch
        position: new THREE.Vector3(7, 0, 2),
        // Where the camera should look at
        target: new THREE.Vector3(-4, 0, 2),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        constraints: {
            minPolarAngle: Math.PI / 3.5,
            maxPolarAngle: Math.PI / 2.1,
            minAzimuthAngle: -Math.PI / 5, // Left rotation limit
            maxAzimuthAngle: Math.PI / 5,  // Right rotation limit  
            minDistance: 1.2,
            maxDistance: 4.5,
            dampingFactor: 0.08
        }
    },

    trunkCargo: {
        // Camera position when viewing trunk cargo - positioned behind and above the car
        position: new THREE.Vector3(0, 3.5, -8),
        // Where the camera should look at - focus on the rear/trunk area of the car
        target: new THREE.Vector3(0, 0.5, -2.0),
        // Whether to lock the camera at this position (default: true)
        lockCamera: false,
        // Camera movement constraints when in this hotspot view
        constraints: {
            minPolarAngle: Math.PI / 4,
            maxPolarAngle: Math.PI / 2.2,
            minAzimuthAngle: Math.PI / 0.36, // Left rotation limit (-45 degrees)
            maxAzimuthAngle: -Math.PI / 0.36,  // Right rotation limit (45 degrees)
            minDistance: 3.0,              // Closest zoom
            maxDistance: 20,              // Farthest zoom
            dampingFactor: 0.08            // Smoothness of movement
        }
    },

    comfort: {
        // Camera position when viewing front seats/comfort features - positioned for interior view
        position: new THREE.Vector3(-0.25, 1.7, 0),
        // Where the camera should look at - focus on the front seats area
        target: new THREE.Vector3(0.25, 1.4, -0.3),
        // Whether to lock the camera at this position (default: true)
        lockCamera: true,
        // Camera movement constraints when in this hotspot view - adjusted for interior
        constraints: {
            minPolarAngle: Math.PI / 6, // Minimum vertical angle (allows looking up more for interior)
            maxPolarAngle: Math.PI / 2.2,  // Maximum vertical angle (prevents looking too far down)
            minAzimuthAngle: -Math.PI / 3, // Left rotation limit (-60 degrees for interior)
            maxAzimuthAngle: Math.PI / 3,  // Right rotation limit (60 degrees for interior)
            minDistance: 0.5,              // Closer zoom for interior details
            maxDistance: 3.0,              // Shorter max distance for interior
            dampingFactor: 0.1            // Slightly more damping for interior precision
        }
    },

    controlAtYourFingerTips: {
        // Camera position when viewing BMW Interaction Bar - move back to see front better
        position: new THREE.Vector3(0, 1.7, -1),
        // Target should look forward at the interaction bar/dashboard area (fixed point to orbit around)
        target: new THREE.Vector3(0, 1.2, 0.3),
        // Whether to lock the camera at this position (default: true)
        lockCamera: false,
        // Special flag to use dynamic targeting like interior mode
        useDynamicTarget: false,
        // Camera movement constraints - limited rotation around fixed target
        constraints: {
            minDistance: 0.1,  // Match the starting distance to prevent jump
            maxDistance: 1.5,  // Prevent zooming too far
            minPolarAngle: Math.PI / 2.5, // Limited vertical up movement
            maxPolarAngle: Math.PI / 3,    // Limited vertical down movement
            minAzimuthAngle: Math.PI / 0.37, // Allow left rotation (-30 degrees)
            maxAzimuthAngle: -Math.PI / 0.37,  // Allow right rotation (30 degrees)
            dampingFactor: 0.08  // Smoother damping for natural feel
        }
    },

    techFocused: {
        // Camera position when viewing Tech Focused screens - positioned to see dashboard/front screens
        position: new THREE.Vector3(0, 1.7, -1),
        // Target should point forward to the dashboard screens (negative z to look forward)
        target: new THREE.Vector3(0, 1.2, 0.4),
        // Whether to lock the camera at this position (default: true)
        lockCamera: false,
        // Special flag to use dynamic targeting like interior mode
        useDynamicTarget: false,
        // Camera movement constraints - same as interior mode but with limited left/right rotation
        constraints: {
            minDistance: 0.1,  // Match the starting distance to prevent jump
            maxDistance: 1.5,  // Prevent zooming too far
            minPolarAngle: Math.PI / 2.5, // Limited vertical up movement
            maxPolarAngle: Math.PI / 2,    // Limited vertical down movement
            minAzimuthAngle: Math.PI / 0.37, // Allow left rotation (-30 degrees)
            maxAzimuthAngle: -Math.PI / 0.37,  // Allow right rotation (30 degrees)
            dampingFactor: 0.08  // Smoother damping for natural feel
        }
    },

    motorsportDNA: {
        // Camera position when viewing motorsport DNA - positioned to see steering wheel
        position: new THREE.Vector3(0.6, 1.8, -0.8),
        // Target should point forward to the dashboard screens (negative z to look forward)
        target: new THREE.Vector3(0.5, 1.4, 0.4),
        // Keep camera unlocked so rotation is allowed
        lockCamera: false,
        // Camera movement constraints - limited rotation around steering wheel
        constraints: {
            minDistance: 0.1,  // Allow close-up view
            maxDistance: 1.5,  // Prevent zooming too far
            minPolarAngle: Math.PI / 2.5, // Limited vertical up movement
            maxPolarAngle: Math.PI / 2,    // Limited vertical down movement
            minAzimuthAngle: Math.PI / 1.05, // Allow left rotation (-60 degrees)
            maxAzimuthAngle: -Math.PI / 1.05,  // Allow right rotation (60 degrees)
            dampingFactor: 0.08  // Smoother damping for natural feel
        }
    },

    rearSpace: {
        // Camera position for rear leg room view - positioned slightly above and inside the cabin
        position: new THREE.Vector3(0.4, 1.6, -1.5),
        // Focus on rear seat leg area
        target: new THREE.Vector3(-0.4, 1.6, -1.5),
        lockCamera: false,
        useDynamicTarget: true,
        constraints: {
            minDistance: 0.1,  // Match the starting distance to prevent jump
            maxDistance: 1,  // Prevent zooming too far
            minPolarAngle: Math.PI / 2.5, // Allow looking up
            maxPolarAngle: Math.PI / 2,  // Allow looking down slightly (reduced)
            minAzimuthAngle: -Math.PI / 60, // Allow more left rotation (90 degrees)
            maxAzimuthAngle: Math.PI / 1.8,  // Restrict right rotation (~3 degrees)
            dampingFactor: 0.08  // Smoother damping for natural feel
        }
    }
}

// Tips for adjusting positions:
// 
// POSITION (where the camera is located):
// - x: positive = right side of car, negative = left side
// - y: positive = higher up, negative = lower down
// - z: positive = in front of car, negative = behind car
//
// TARGET (where the camera looks at):
// - Should be slightly closer to the car than the position
// - Usually points toward the specific part you want to focus on
//
// LOCK CAMERA:
// - lockCamera: true (default) = camera is locked at target position, no rotation allowed
// - lockCamera: false = camera can be rotated after reaching target position
//
// CONSTRAINTS:
// - minPolarAngle/maxPolarAngle: vertical rotation limits (0 = straight up, π/2 = horizontal)
// - minAzimuthAngle/maxAzimuthAngle: horizontal rotation limits (radians, use π/6 ≈ 30°)
// - minDistance/maxDistance: zoom limits
// - dampingFactor: how smooth the camera movement feels (0.05-0.1 is good)

export default CUSTOM_HOTSPOT_POSITIONS